import React, { PureComponent, Fragment } from 'react';

interface IProps {
  theme: any;
}

class ThemeProvider extends PureComponent<IProps> {
  render() {
    return (
      <Fragment>
        <style>{this.props.theme}</style>
        {this.props.children}
      </Fragment>
    );
  }
}

export default ThemeProvider;
